import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { Flex } from 'shared/ui/flex';
import { FC, Fragment, useEffect, useState } from 'react';
import { formatTime } from 'shared/lib/time';

import { TextCard } from 'shared/ui/cards/textCard';
import { formatWithLocale } from 'shared/lib/datepicker';
import { MarginBottom } from './styles';
import { Order } from 'entities/orders';

export const OrderTimeVisit: FC<{ order: Order | null }> = ({ order }) => {
	const EnhancedTypography = withTypographyContainer(Typography);
	const [visit, setVisit] = useState('');

	useEffect(() => {
		if (order) {
			if (order.dt_start) {
				const start = formatTime({
					time: order.appointment.dt_visit_start,
				});
				const end = formatTime({
					time: order.appointment.dt_visit_end,
				});
				if (start && end) {
					setVisit(
						`${formatWithLocale(
							new Date(order.appointment.dt_visit_start),
							'd MMM EEE',
						)} ${start.time} - ${formatWithLocale(
							new Date(order.appointment.dt_visit_end),
							'd MMM EEE',
						)} ${end.time}`,
					);
				}
			}
		}
	}, [order]);

	return (
		<Fragment>
			{order && (
				<MarginBottom>
					<Flex $justify="space-between" $wrap="wrap" $gap="10px">
						<div>
							<EnhancedTypography mode="small">
								Дата и Время визита
							</EnhancedTypography>
							<TextCard>{visit}</TextCard>
						</div>
					</Flex>
				</MarginBottom>
			)}
		</Fragment>
	);
};
